import { render, staticRenderFns } from "./EllipseSolidTopBarIcon.vue?vue&type=template&id=6f5a55be&"
import script from "./EllipseSolidTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./EllipseSolidTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports